import type { ComponentType } from "react";

export const localeRoot = "settings.paywalls.modal.tabs.checkout";

export const BADGE_TOGGLE_NAME =
  "paywall_customization_attributes.badge_properties.enabled";
export const BADGE_TOGGLE_DATA_TEST_ID = "paywall-customization-badge-toggle";
export const BENEFIT_TOGGLE_NAME =
  "paywall_customization_attributes.benefit_properties.enabled";
export const BENEFIT_TOGGLE_DATA_TEST_ID =
  "paywall-customization-benefit-toggle";
export const TESTIMONIAL_TOGGLE_NAME =
  "paywall_customization_attributes.testimonial_properties.enabled";
export const TESTIMONIAL_TOGGLE_DATA_TEST_ID =
  "paywall-customization-testimonial-toggle";
export const COUNTDOWN_TOGGLE_NAME =
  "paywall_customization_attributes.countdown_properties.enabled";
export const COUNTDOWN_TOGGLE_DATA_TEST_ID =
  "paywall-customization-countdown-toggle";
export const MEDIA_BLOCKS_TOGGLE_NAME =
  "paywall_customization_attributes.media_block_properties.enabled";
export const MEDIA_BLOCKS_TOGGLE_DATA_TEST_ID =
  "paywall-customization-media-blocks-toggle";

export interface SidebarEntry {
  Component: ComponentType;
  title: string;
  toggleDataTestId?: string;
  toggleName?: string;
}

export const PROPERTIES = {
  DEFAULT: "default",
  TESTIMONIALS: "testimonials",
  BADGES: "badges",
  BENEFITS: "benefits",
  COUNTDOWN: "countdown",
  PRICE_CALLOUTS: "price_callouts",
  REDUCED_PRICES: "reduced_prices",

  // Upsell
  DETAILED: "detailed",
  MEDIA_BLOCKS: "media_blocks",
  BUTTONS: "buttons",
};

export const DISPLAY_STYLE_OPTIONS = {
  STARS: "stars",
  QUOTATION_MARK: "quotation_mark",
};

export const DISPLAY_STYLE_DEFAULT_COLORS = {
  STARS: "#FDB022",
  QUOTATION_MARK: "#000000",
};

const mediaBlockForm = "media_block_properties.media_blocks";

export const PaywallCustomizationFields = (
  root: string = "paywall_customization_attributes",
) => ({
  media_block_properties: {
    enabled: [root, "media_block_properties.enabled"].join("."),
    media_blocks: (index: number) => ({
      ROOT: [root, mediaBlockForm, index].join("."),
      title: [root, mediaBlockForm, index, "title"].join("."),
      description: [root, mediaBlockForm, index, "description"].join("."),
      background_color: [root, mediaBlockForm, index, "background_color"].join(
        ".",
      ),
      cover: {
        ROOT: [root, mediaBlockForm, index, "cover"].join("."),
        signed_id: [root, mediaBlockForm, index, "cover.signed_id"].join("."),
        content_type: [root, mediaBlockForm, index, "cover.content_type"].join(
          ".",
        ),
        url: [root, mediaBlockForm, index, "cover.url"].join("."),
        filename: [root, mediaBlockForm, index, "cover.filename"].join("."),
      },
    }),
  },
});
